import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clemos-message-footer',
  templateUrl: './message-footer.component.html',
  styleUrls: ['./message-footer.component.css']
})
export class MessageFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
